import script from "./PaginatedTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginatedTable.vue?vue&type=script&setup=true&lang=ts"

import "./PaginatedTable.vue?vue&type=style&index=0&id=26cb3b1a&lang=scss&scoped=true"
import "./PaginatedTable.vue?vue&type=style&index=1&id=26cb3b1a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26cb3b1a"]])

export default __exports__